// removed by extract-text-webpack-plugin
module.exports = {"HR":"HrText-module__HR__3Eewr","HRLine":"HrText-module__HRLine__1JQdQ","HRText":"HrText-module__HRText__2jb-S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/HrText/HrText.module.css
// module id = 1703
// module chunks = 31